import { AccountTypeNames } from '@medentee/enums'

import { State } from 'redux/rootReducer'

export const getCommunityBasePathSelector = (communityId?: string | null) => (state: State) =>
  state.global.accountData?.type.name === AccountTypeNames.PROFESSIONAL
    ? `/communities/${communityId}`
    : '/community'
